import { useConfig, showToast } from '../hooks/useApi';
import { TopBar, Breadcrumb, ImageFB } from '../components';

export function Contact() {
  const config = useConfig();

  if (!config) {
    return (
      <div>
        <TopBar title="Contact" showBack />
        <div className="skeleton" style={{ height: 120, margin: 'var(--s-4)', borderRadius: 'var(--r-card)' }} />
      </div>
    );
  }

  const copyViber = () => {
    navigator.clipboard?.writeText(config.viber).then(() => {
      showToast('Viber ID copied');
    }).catch(() => {
      showToast('Copy failed: ' + config.viber);
    });
  };

  const callPhone = () => {
    window.location.href = `tel:${config.phone}`;
  };

  return (
    <div>
      <TopBar title="Contact" showBack />
      <Breadcrumb items={[
        { label: 'Home', to: '/' },
        { label: 'Contact' },
      ]} />

      <div className="contact-page">
        <div className="contact-card">
          <div className="ci">
            <div className="ico viber">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 3C7 3 3 6.6 3 10.9c0 2.3 1.2 4.4 3.1 5.8L5.2 20.5l3.5-1.9c.9.3 1.9.5 2.9.5 5 0 9-3.6 9-8S17 3 12 3z" />
              </svg>
            </div>
            <div>
              <div className="t">Viber ID</div>
              <div className="v">{config.viber}</div>
            </div>
          </div>
          <button className="act alt" onClick={copyViber}>Copy Viber ID</button>
        </div>

        <div className="contact-card">
          <div className="ci">
            <div className="ico phone">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M6.6 10.8c1.4 2.8 3.8 5.2 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.6.1.4 0 .8-.2 1l-2.3 2.2z" />
              </svg>
            </div>
            <div>
              <div className="t">Phone</div>
              <div className="v">{config.phone}</div>
            </div>
          </div>
          <button className="act" onClick={callPhone}>Make a Call</button>
        </div>

        {config.contactTip && (
          <div className="contact-tip">{config.contactTip}</div>
        )}
      </div>
    </div>
  );
}
